import React from 'react'
import PropTypes from 'prop-types'

const AboutIcon = props => {
  return props.active ? (
    <svg
      aria-hidden="true"
      className="navigation-icon active"
      width="66"
      height="68"
      viewBox="0 0 70 76"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>About</title>
      <defs>
        <filter
          x="-102.9%"
          y="-87.5%"
          width="305.9%"
          height="275%"
          filterUnits="objectBoundingBox"
          id="about_filter"
        >
          <feOffset in="SourceAlpha" result="shadowOffsetOuter1" />
          <feGaussianBlur stdDeviation="9" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
          <feColorMatrix
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
            in="shadowBlurOuter1"
            result="shadowMatrixOuter1"
          />
          <feMerge>
            <feMergeNode in="shadowMatrixOuter1" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
        <path id="about_path" d="M0 .16h34V40H0z" />
      </defs>
      <g filter="url(#about_filter)" transform="translate(18 18)" fill="none" fillRule="evenodd">
        <mask id="about_mask" fill="#fff">
          <use href="#about_path" />
        </mask>
        <path
          d="M30.842 15.02c0 3.373-1.026 5.987-3.053 7.76-2.21 1.94-5.597 2.92-10.07 2.927h-4.393l.006 11.06-10.141.006-.026-33.38 13.88-.013h.034c4.975 0 8.624 1.06 10.84 3.14 1.962 1.84 2.917 4.553 2.923 8.293v.207zm-.785-10.873C27.2 1.46 22.957.16 17.08.16h-.033L0 .173.026 40l16.47-.013-.006-11.06h1.23c5.25 0 9.33-1.247 12.128-3.7 2.76-2.414 4.159-5.854 4.152-10.207v-.207c0-4.626-1.327-8.213-3.943-10.666z"
          fill="#FFF"
          mask="url(#about_mask)"
        />
        <path
          d="M18.995 14.997c0 .634-.182 1.13-.531 1.474-.335.331-.8.49-1.39.49l-1.062.007-.007-3.936h1.091c.59 0 1.033.145 1.36.441.357.331.54.814.54 1.44v.084zm1.383-3.88C19.403 10.364 18.057 10 16.28 10H13l.007 10h3.216c1.768 0 3.18-.42 4.176-1.247 1.063-.89 1.601-2.15 1.601-3.756v-.214c0-1.599-.546-2.833-1.622-3.667z"
          fill="#FFF"
        />
      </g>
    </svg>
  ) : (
    <svg
      aria-hidden="true"
      className="navigation-icon"
      width="66"
      height="68"
      viewBox="0 0 70 76"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>About</title>
      <defs>
        <path id="about_path" d="M0 .16h34V40H0z" />
      </defs>
      <g fill="none" fillRule="evenodd">
        <g transform="translate(18 18)">
          <mask id="about_mask" fill="#fff">
            <use href="#about_path" />
          </mask>
          <path
            d="M30.842 15.02c0 3.373-1.026 5.987-3.053 7.76-2.21 1.94-5.597 2.92-10.07 2.927h-4.393l.006 11.06-10.141.006-.026-33.38 13.88-.013h.034c4.975 0 8.624 1.06 10.84 3.14 1.962 1.84 2.917 4.553 2.923 8.293v.207zm-.785-10.873C27.2 1.46 22.957.16 17.08.16h-.033L0 .173.026 40l16.47-.013-.006-11.06h1.23c5.25 0 9.33-1.247 12.128-3.7 2.76-2.414 4.159-5.854 4.152-10.207v-.207c0-4.626-1.327-8.213-3.943-10.666z"
            fill="#FFF"
            mask="url(#about_mask)"
          />
        </g>
        <path
          d="M36.995 32.997c0 .634-.182 1.13-.531 1.474-.335.331-.8.49-1.39.49l-1.062.007-.007-3.936h1.091c.59 0 1.033.145 1.36.441.357.331.54.814.54 1.44v.084zm1.383-3.88C37.403 28.364 36.057 28 34.28 28H31l.007 10h3.216c1.768 0 3.18-.42 4.176-1.247 1.063-.89 1.601-2.15 1.601-3.756v-.214c0-1.599-.546-2.833-1.622-3.667z"
          fill="#FFF"
        />
      </g>
    </svg>
  )
}

Window.propTypes = {
  active: PropTypes.string
}

export default AboutIcon
